import { FirestoreService2 } from './firestore.service2'
import { Injectable } from '@angular/core'
import { AsyncValidator, ValidationErrors } from "@angular/forms"
import { from, Observable } from 'rxjs'
import { map } from "rxjs/operators"
import { use } from './utils'

@Injectable({ providedIn: 'root' })
export class ValidationService implements AsyncValidator {
  constructor() { console.info(`## ${this.constructor.name}`) }

  validate(params): Observable<ValidationErrors | null> {
    const fss2 = use<FirestoreService2>(FirestoreService2)
    return from(fss2.toPromise(fss2.list(params.collection, { where: [[params.field, '==', params.value]] })))
      .pipe(map(res => res[0] ? { unique: true } : null))
  }
}
